// extracted by mini-css-extract-plugin
export default {"div":"textarea_div__CV5+l","textarea":"textarea_textarea__8Ll9J","label":"textarea_label__QXJTb"};